"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur es ahora parte de SAP.',
    learn: {
      href: '/sap',
      text: 'Más información al respecto'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'CONCUR BLOG',
      href: ''
    }, {
      text: 'CONTÁCTE',
      href: '/contacte'
    }],
    selector: 'Selección de País/Región',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Política de privacidad',
      href: ''
    }, {
      text: 'Condiciones de uso',
      href: ''
    }]
  }
};